import { render } from "./ProdukHukum.vue?vue&type=template&id=1f207790"
import script from "./ProdukHukum.vue?vue&type=script&lang=js"
export * from "./ProdukHukum.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__